var map = {
	"./16.png": "./ico/16.png",
	"./32.png": "./ico/32.png",
	"./48.png": "./ico/48.png",
	"./64.png": "./ico/64.png",
	"./favicon.ico": "./ico/favicon.ico",
	"./favicon_114.png": "./ico/favicon_114.png",
	"./favicon_120.png": "./ico/favicon_120.png",
	"./favicon_144.png": "./ico/favicon_144.png",
	"./favicon_152.png": "./ico/favicon_152.png",
	"./favicon_167.png": "./ico/favicon_167.png",
	"./favicon_180.png": "./ico/favicon_180.png",
	"./favicon_57.png": "./ico/favicon_57.png",
	"./favicon_60.png": "./ico/favicon_60.png",
	"./favicon_72.png": "./ico/favicon_72.png",
	"./favicon_76.png": "./ico/favicon_76.png",
	"./favicon_fb.png": "./ico/favicon_fb.png",
	"./ico BID.png": "./ico/ico BID.png",
	"./windows_large.png": "./ico/windows_large.png",
	"./windows_square.png": "./ico/windows_square.png",
	"./windows_tiny.png": "./ico/windows_tiny.png",
	"./windows_wide.png": "./ico/windows_wide.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ico sync recursive ^\\.\\/.*$";